<!--
    描述：造价预览首页
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="cost-overview-main">
		<el-tabs v-model="activeName"
				 @tab-click="handleClick">
			<el-tab-pane v-for="(item, index) in overviewList"
						 :key="item.name"
						 :label="item.label"
						 :name="item.name">
				<transition name="fade"
							mode="out-in">
					<overview-info :formInfo="formInfo"
								   :tableData="tableData"
								   :tableList="tableList"
								   :ref="item.name"></overview-info>
				</transition>

			</el-tab-pane>
		</el-tabs>

		<!-- 导出按钮 -->
		<div class="btn-export">
			<el-button type="primary"
					   plain
					   size="mini"
					   icon="el-icon-download"
					   v-if="roleBtns.includes('overview-Excel') || curSource === '1'"
					   @click="doExport('excel')">导出Excel</el-button>
			<el-button icon="el-icon-upload"
					   size="mini"
					   v-if="roleBtns.includes('overview-Html') || curSource === '1'"
					   @click="doExport('html')">导出Html</el-button>
		</div>
	</div>
</template>
<script>
import overviewInfo from './overview_info'
import { getProjectCost } from '@/api/modules/dataProject'
import { mapState } from 'vuex'
export default {
	name: 'Cost-overview',
	components: {
		overviewInfo
	},
	data() {
		return {
			activeName: '1007001', // 当前展示的 tab 页面
			overviewList: [
				{
					label: '概算价',
					name: '1007001'
				},
				{
					label: '控制价',
					name: '1007002'
				},
				{
					label: '中标价',
					name: '1007003'
				},
				{
					label: '报审价',
					name: '1007004'
				},
				{
					label: '初审价',
					name: '1007005'
				},
				{
					label: '审定价',
					name: '1007006'
				}
			],
			//基础信息
			formInfo: {
				companyName: '', // 编制单位
				taskUser: '', // 编制人
				editDate: '', // 编制日期
				basisQuotaName: '', // 清单定额依据
				basisPriceName: '', // 信息价
				softwareName: '' // 计价软件
			},
			// 表格数据
			tableData: [],
			tableList: [], // 原始数据
			isBegin: false
		}
	},
	methods: {
		// 切换tab 的事件
		handleClick(tab) {
			// 不同tab 的信息
			this.getInfo(tab.name)
		},
		// 获取对应的tab 的全部信息
		getInfo(phaseValue) {
			// 先清空数组
			this.tableData = []
			getProjectCost({ aid: this.curProjectId, phase: phaseValue })
				.then(res => {
					if (res.data.list) {
						this.tableList = res.data.list || []
						let _arr = this.$utils.toArrayTree(res.data.list, {
							parentKey: 'pid'
						})
						// console.log(_arr)
						this.tableData = _arr
						// this.tableData.push(res.data.busProContract)
					}
					if (res.data.basicInfo) {
						this.formInfo = res.data.basicInfo
					} else {
						this.clearForm()
					}
				})
				.catch(err => {
					this.$emit('delProject')
					this.$message.error(
						'项目不存在 或 已被删除， 请重新选择分析!'
					)
				})
		},
		// 清空表单信息
		clearForm() {
			this.formInfo.companyName = ''
			this.formInfo.taskUser = ''
			this.formInfo.editDate = ''
			this.formInfo.basisQuotaName = ''
			this.formInfo.basisPriceName = ''
			this.formInfo.softwareName = ''
		},

		// 点击导出Excel
		doExport(type) {
			let fileName =
				this.overviewList.find(x => x.name === this.activeName).label ||
				''
			this.$refs[this.activeName][0].doExport(fileName, type)
		}
	},
	created() {
		this.isBegin = true
		// 初始加载第一个 概算价
		if (this.curProjectId) {
			this.getInfo('1007001')
			this.isBegin = false
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),
		curProjectId() {
			return this.$route.query.projectId || null
		},
	},
	watch: {
		// 监听项目ID 的变化
		curProjectId(val) {
			// console.log(val)
			if (this.isBegin) {
				return
			}
			this.getInfo(this.activeName)
		}
	}
}
</script>

<style lang="less" scoped>
.cost-overview-main {
	height: 100%;
	background-color: #fff;
	padding: 0 10px;
	color: #666;
	position: relative;

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-form-item__label {
		line-height: 30px;
	}

	/deep/ .el-form-item__content {
		line-height: 30px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.btn-export {
		position: absolute;
		margin-top: 3px;
		right: 20px;
		top: 3px;
		z-index: 10;
	}
}
</style>